import dialogUtil from '../../_helpers/dialogUtil';
import apiStatus from '../../_helpers/apiStatus';

class CpwdController {
  constructor($stateParams, $state, AuthService) {
    "ngInject";

    this.name = 'changePassword';
    this.token = $stateParams.id;  //This would be null if changing on the site; set if from email link
    this.authService = AuthService;
    this.state = $state;
    this.currentYear = new Date().getFullYear();
    //If coming from email reset, go to login; otherwise main page
    this.redirect = (this.token) ? "auth.login" : "main.home";
  }

  $onInit() {

  }

  resetPassword() {
    let password = $("#m_password").val()
    let rePassword = $("#m_repassword").val()

    if (this.validate(password, rePassword)) {
      // If id is passed it, then coming from external link from email. So set session
      this.authService.resetPassword(this.token, password, (result) => {
        if (result.apiStatus === apiStatus.SUCCESS) {
          this.redirectToPage();
          dialogUtil.showSuccessMessage("Your password has been changed. Please use the new password on your next login!")
        } else if (result.apiStatus === apiStatus.INVALID_CHANGE_PASSWORD_SESSION) {
          dialogUtil.showErrorMessage("Your password reset link has expired.  You can request another link by using Forgot Password")
        } else if (result.apiStatus === apiStatus.INVALID_PASSWORD_TOO_SHORT) {
          dialogUtil.showErrorMessage("Your password is too short")
        } else if (result.apiStatus === apiStatus.INVALID_PASSWORD_COMMON_WORD) {
          dialogUtil.showErrorMessage("Your password contains a common word")
        } else if (result.apiStatus === apiStatus.INVALID_PASSWORD_DUP_OR_SEQ) {
          dialogUtil.showErrorMessage("Your password contains 3 or more duplicate or sequential characters")
        } else {
          dialogUtil.showErrorMessage("Something went wrong!")
        }
      })
    }
  }

  validate(password, rePassword) {
    let isValid = true
    if (password.length < 8) {
      dialogUtil.showErrorMessage("Password should have a minimum of eight characters!")
      isValid = false
    } else if (password !== rePassword) {
      dialogUtil.showErrorMessage("Passwords do not match!")
      isValid = false
    }

    return isValid
  }

  redirectToPage() {
    this.state.go(this.redirect)
  }
}

export default CpwdController;



// WEBPACK FOOTER //
// ./client/app/common/cpwd/cpwd.controller.js